import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from './../Reusable/Elements';

const Forbidden = (props) => {

    const { t } = useTranslation();

    return (
        <div className="forbidden">
            <PageTitle title={t('navigation.forbidden')} hideInfo />
            <p>403</p>
        </div>
    );

}

export default Forbidden;
